/* app/js/src/components/scheduler/libraryItem/graphic/graphicLibraryItem.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.cursor-pointer {
  cursor: pointer;
}
.upload-item-base {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-flex: 1 0 0;
  -ms-flex: 1 0 0;
  flex: 1 0 0;
  max-width: calc(49% - 5px);
  min-width: calc(49% - 5px);
  width: calc(49% - 5px);
  position: relative;
}
.upload-item-base > span {
  display: block;
  position: absolute;
  bottom: 7.5%;
  white-space: nowrap;
  left: 17.5%;
  width: 65%;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 0.7em;
  letter-spacing: 0.1px;
  color: #879baf;
  text-transform: uppercase;
  text-align: center;
}
.upload-item-base button {
  background-color: #eef2f6;
  height: 22px;
  width: 22px;
  border-radius: 50%;
  position: absolute;
  top: 5%;
  right: 5%;
  border: none;
  padding: 0;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.upload-item-base button svg {
  width: 12px;
  height: 12px;
  fill: #879baf;
}
.upload-item-base button:focus {
  outline: none;
}
.upload-item-base button:hover {
  background-color: #879baf;
}
.upload-item-base button:hover svg {
  fill: #fdfefe;
}
.library-item {
  position: relative;
  overflow: visible;
  background: #ffffff;
  max-width: 100%;
  -webkit-flex: 1 0 0;
  -ms-flex: 1 0 0;
  flex: 1 0 0;
  -webkit-transition: all 0.1s ease;
  transition: all 0.1s ease;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  flex-direction: column;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
}
.library-item > section {
  -webkit-flex: 6 1 0;
  -ms-flex: 6 1 0;
  flex: 6 1 0;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  position: relative;
}
.library-item > section .color-curtain {
  background-color: red;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-flex: 1 1 0;
  -ms-flex: 1 1 0;
  flex: 1 1 0;
}
.library-item > section .color-curtain label {
  color: #ffffff;
  text-transform: uppercase;
  font-weight: 300;
  font-size: 0.85em;
}
.library-item > section .image-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: contain;
}
.library-item footer {
  position: relative;
  -webkit-flex: 1 0 0;
  -ms-flex: 1 0 0;
  flex: 1 0 0;
  background-color: #ffffff;
  width: 100%;
  padding: 9px 8px 11px;
  color: #232f3a;
  font-size: 0.7em;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}
.library-item footer span {
  -webkit-flex: 2 0 0;
  -ms-flex: 2 0 0;
  flex: 2 0 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-right: 5%;
}
.library-item footer span.item-duration {
  position: absolute;
  top: -28px;
  padding: 4px;
  left: 4px;
  font-size: 10px;
  letter-spacing: 0.1px;
  color: white;
  background-color: rgba(0, 0, 0, 0.6);
}
.library-item footer a {
  cursor: move;
}
.library-item footer a svg {
  fill: #b9bec9;
  width: 7px;
  height: 12px;
}
.library-item .hover-layer {
  background-color: rgba(35, 47, 58, 0.8);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  display: none;
  animation: fadeIn 0.3s forwards;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}
.library-item .hover-layer.space-around section {
  -webkit-justify-content: space-around;
  -ms-flex-pack: space-around;
  justify-content: space-around;
}
.library-item .hover-layer section {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  justify-content: space-between;
  width: 70%;
  margin: 0 auto;
}
.library-item .hover-layer section > button {
  display: block;
  width: 20px;
  height: 20px;
  background: none;
  border: none;
  padding: 0;
  position: relative;
  cursor: pointer;
}
.library-item .hover-layer section > button > input[type=file] {
  position: absolute;
  width: 100%;
  height: 100%;
  opacity: 0;
  padding-left: 20px;
  margin-right: -20px;
  cursor: pointer;
}
.library-item .hover-layer section > button > svg,
.library-item .hover-layer section > button ::ng-deep > svg {
  width: 20px;
  height: 20px;
  fill: #93a9bf !important;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.library-item .hover-layer section > button:focus {
  outline: none;
}
.library-item .hover-layer section > button:hover > svg {
  fill: #ffffff;
}
.library-item .hover-layer section > button:hover::after {
  -ms-transform: translateY(5px);
  -webkit-transform: translateY(5px);
  transform: translateY(5px);
  opacity: 1;
}
.library-item .hover-layer section > button::after {
  content: attr(data-title);
  color: #ffffff;
  font-size: 0.7em;
  margin-left: -10px;
  display: block;
  opacity: 0;
  position: absolute;
  left: -50%;
  top: 23px;
  width: 300%;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  -ms-transform: translateY(15px);
  -webkit-transform: translateY(15px);
  transform: translateY(15px);
}
.library-item:hover .hover-layer {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}
.library-item.list-mode {
  flex-direction: row;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
}
.library-item.list-mode > section {
  -webkit-flex: 1 1 0;
  -ms-flex: 1 1 0;
  flex: 1 1 0;
  max-width: 25%;
  min-width: 25%;
}
.library-item.list-mode .hover-layer {
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
}
.library-item.list-mode .hover-layer > section {
  width: 90%;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
}
.library-item.list-mode .hover-layer > section button {
  margin: 0 20px;
}
.library-item.list-mode .hover-layer > section button::after {
  font-size: 0.5em;
}
.library-item.list-mode footer {
  flex-direction: column-reverse;
  -webkit-flex-direction: column-reverse;
  -ms-flex-direction: column-reverse;
}
.library-item.list-mode footer .media-icon {
  top: 26px;
  padding: 5px;
  right: 8px;
}
.library-item.list-mode footer .media-icon.recording {
  top: 21px;
}
.library-item.list-mode footer span {
  width: 250px;
  position: static;
  font-size: 1.2em;
}
.library-item.list-mode footer span.item-duration {
  padding: 0;
  background: none;
  color: #879baf;
  font-size: 1em;
}
.library-item .multiple-delete {
  position: absolute;
  background-color: blue;
  right: -100px;
  width: 400px;
}
.dragged {
  opacity: 0.7;
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.media-icon {
  position: absolute;
  top: -33px;
  padding: 4px;
  right: 4px;
  width: 32px;
  height: 32px;
}
.low-quality {
  cursor: pointer;
}
.over-hover-layer {
  z-index: 3;
}
.library-item .hover-layer > section {
  -webkit-justify-content: space-around;
  -ms-flex-pack: space-around;
  justify-content: space-around;
}
.library-item .hover-layer .svg-icon {
  width: 20px;
  height: 20px;
  position: relative;
}
.library-item .hover-layer .svg-icon ::ng-deep path {
  fill: #93a9bf !important;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.library-item .hover-layer .svg-icon:hover {
  cursor: pointer;
}
.library-item .hover-layer .svg-icon:hover ::ng-deep {
  height: 20px;
  width: 20px;
}
.library-item .hover-layer .svg-icon:hover ::ng-deep path {
  fill: #ffffff !important;
}
.library-item .hover-layer .svg-icon:hover::after {
  -ms-transform: translateY(5px);
  -webkit-transform: translateY(5px);
  transform: translateY(5px);
  opacity: 1;
}
.library-item .hover-layer .svg-icon::after {
  content: "INSTANCES";
  color: #ffffff;
  font-size: 0.7em;
  margin-left: -10px;
  display: block;
  opacity: 0;
  position: absolute;
  left: -50%;
  width: 300%;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  -ms-transform: translateY(15px);
  -webkit-transform: translateY(15px);
  transform: translateY(15px);
}
.library-item.list-mode .hover-layer .svg-icon {
  margin: 0 20px;
}
.library-item.list-mode .hover-layer .svg-icon::after {
  font-size: 0.5em;
}
/*# sourceMappingURL=graphicLibraryItem.component.css.map */
